var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaboration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24H12.422L7.29769 10.4911L0 24Z",
    fill: "#F2962E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93118 0L0.843506 13.5089L13.8098 6.75445L1.93118 0Z",
    fill: "#F2962E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.576 0L16.7023 13.5089L24 0H11.576Z",
    fill: "#F2962E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.191 17.2456L22.0697 24L23.1569 10.4906L10.191 17.2456Z",
    fill: "#F2962E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1928 9.60008C11.5921 9.6119 11.0163 9.86262 10.5741 10.3048C10.1319 10.7471 9.85404 11.3501 9.79299 12C9.76217 12.3056 9.79156 12.6148 9.8792 12.907C9.96684 13.1993 10.1107 13.4679 10.3013 13.6949C10.4918 13.922 10.7246 14.1023 10.9842 14.2239C11.2439 14.3455 11.5243 14.4055 11.8069 14.4C12.4075 14.388 12.9832 14.1373 13.4253 13.6951C13.8674 13.2529 14.1452 12.6499 14.2062 12C14.237 11.6945 14.2076 11.3853 14.12 11.093C14.0324 10.8008 13.8885 10.5322 13.698 10.3051C13.5074 10.0781 13.2746 9.89775 13.015 9.77618C12.7553 9.65461 12.4749 9.59458 12.1923 9.60008",
    fill: "#F2962E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/collaboration.5210ffd7084a5cfed6f74e3655eb4efe.svg";
export { ForwardRef as ReactComponent };